import React from "react";
import "./HomeOperativa.css";

const HomeOperativa = ({
  richiesteDaClassificare = [],
  interventiAperti = [],
  flottaInterventoId = null,
  onNavigate,
}) => {
  const richieste = Array.isArray(richiesteDaClassificare)
    ? richiesteDaClassificare
    : [];

  const interventi = Array.isArray(interventiAperti)
    ? interventiAperti
    : [];

  const daFare = interventi.filter(
    (intervento) => intervento.stato === "Da fare"
  ).length;

  const inCorso = interventi.filter(
    (intervento) => intervento.stato === "In corso"
  ).length;

  const inPausa = interventi.filter(
    (intervento) => intervento.stato === "In pausa"
  ).length;

  const interventoFlotta = interventi.find(
    (intervento) =>
      Number(intervento.id) === Number(flottaInterventoId)
  );

  const apriSezione = (sezione) => {
    if (typeof onNavigate === "function") {
      onNavigate(sezione);
    }
  };

  return (
    <div className="home-operativa">
      <header className="home-operativa-header">
        <h2>Buongiorno Stefano</h2>
        <p>Situazione operativa di Betalumina</p>
      </header>

      <div className="home-operativa-grid">
        <button
          type="button"
          className="home-operativa-card richieste"
          onClick={() => apriSezione("daClassificare")}
        >
          <strong>{richieste.length}</strong>
          <span>Richieste da classificare</span>
        </button>

        <button
          type="button"
          className="home-operativa-card da-fare"
          onClick={() => apriSezione("attivita")}
        >
          <strong>{daFare}</strong>
          <span>Interventi da fare</span>
        </button>

        <button
          type="button"
          className="home-operativa-card in-corso"
          onClick={() => apriSezione("attivita")}
        >
          <strong>{inCorso}</strong>
          <span>Interventi in corso</span>
        </button>

        <button
          type="button"
          className="home-operativa-card in-pausa"
          onClick={() => apriSezione("attivita")}
        >
          <strong>{inPausa}</strong>
          <span>Interventi in pausa</span>
        </button>
      </div>

      <section className="home-operativa-flotta">
        <div>
          <h3>Fiorino</h3>
          <p>Destinazione operativa corrente</p>
        </div>

        {interventoFlotta ? (
          <div className="home-operativa-destinazione">
            <div>
              <strong>
                {interventoFlotta.cliente || "Cliente non indicato"}
              </strong>

              <span>
                {interventoFlotta.indirizzo ||
                  "Indirizzo non disponibile"}
              </span>

              <small>
                {interventoFlotta.causale ||
                  "Intervento senza causale"}
              </small>
            </div>

            <button
              type="button"
              onClick={() => apriSezione("flotta")}
            >
              Apri Flotta
            </button>
          </div>
        ) : (
          <div className="home-operativa-destinazione">
            <span>Nessun intervento assegnato al Fiorino.</span>

            <button
              type="button"
              onClick={() => apriSezione("attivita")}
            >
              Scegli intervento
            </button>
          </div>
        )}
      </section>
    </div>
  );
};

export default HomeOperativa;
